import React from 'react';
import _ from 'lodash';

import {
  Box,
  Button,
  Grid,
  Paper as MuiPaper,
  styled,
  Typography
} from '@mui/material';
import {
  activityTemplates,
  routeDirectory
} from 'modules';

import { useNavigate } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';
import { authService } from 'iron-forge-react-modules';
import * as dataService from './dataService';



const LogoBox = styled(Box)({
  maxHeight: 48,
  width: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

const LogoImg = styled('img')({
  maxWidth: '100%'
});

const RootBox = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginLeft: theme.spacing(3),
  marginRight: theme.spacing(3)
}));

const StoreNameTypography = styled(Typography)(({
  flex: 1
}));

const Paper = styled(MuiPaper)(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  cursor: 'pointer'
}));

const HeaderGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});



export const StoreListActivity: React.FC = () => {
  const navigate = useNavigate();
  const queryTuple = dataService.useQuery();



  function handleClickStore(storeId: string) {
    navigate(routeDirectory.partner.storeDetail.path(storeId));
  }



  function handleClickLogOut() {
    authService.logOut();
  }



  const content = (
    <RootBox>
      <Grid
        container
        spacing={2}>
        <HeaderGrid item xs={12}>
          <Box>
            <Typography variant="h2">
              Your Stores
            </Typography>

            <Typography>
              Select a store to begin
            </Typography>
          </Box>

          <Box>
            <Button
              variant="contained"
              onClick={handleClickLogOut}>
              Logout
            </Button>
          </Box>
        </HeaderGrid>

        {_.map(queryTuple.data.stores, store => (
          <Grid
            key={store.id}
            item
            xs={12}>
            <Paper
              variant="outlined"
              onClick={_.partial(handleClickStore, store.id)}>
              <LogoBox>
                <LogoImg src={store.logoUrl} />
              </LogoBox>

              <StoreNameTypography>
                {store.name}
              </StoreNameTypography>
              <ArrowForward />
            </Paper>
          </Grid>
        ))}
      </Grid>
    </RootBox>
  );



  return queryTuple.data.isSuperAdmin ? (
    <activityTemplates.AdminActivityTemplate.FC>
      {content}
    </activityTemplates.AdminActivityTemplate.FC>
  ) : (
    <activityTemplates.BaseActivityTemplate.FC>
      {content}
    </activityTemplates.BaseActivityTemplate.FC>
  );
};
